/**
 * The component spreads styleProps onto its `<img>`, a replaced element that
 * honors min/max sizing, margin and padding directly — a wrapper div would
 * only add a redundant element. There is no configuration that changes this,
 * so the answer is the same for every render.
 */
export const resolveNoContainer = (): boolean => false;
